import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Outlet } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { publicApiReact } from 'app/Integration/service/PublicAPI/lib/public-api'

export const PublicAPILayout = observer(() => {
  const entities = useEntitiesContext()

  useEffect(() => {
    window.publicApiReact = publicApiReact(entities)
  }, [])

  return <Outlet />
})
